import { Controller } from "@hotwired/stimulus"

// Manages light / dark / system theme preference.
// Persists choice to localStorage and applies .dark class to <html>.
export default class extends Controller {
  static targets = ["option"]

  connect() {
    this._mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this._onSystemChange = () => this._applyTheme(this._current())
    this._mediaQuery.addEventListener("change", this._onSystemChange)
    this._highlight(this._current())
  }

  disconnect() {
    this._mediaQuery.removeEventListener("change", this._onSystemChange)
  }

  set(event) {
    const theme = event.currentTarget.dataset.theme
    localStorage.setItem("theme", theme)
    this._applyTheme(theme)
    this._highlight(theme)
    // The native shell repaints its own chrome to match (bridge/theme_controller.js).
    window.dispatchEvent(new CustomEvent("theme:change", { detail: { theme } }))
  }

  // ── private ───────────────────────────────────────────────────────────────

  _current() {
    // Same default as the pre-paint script in layouts/application.html.erb, so with no saved
    // choice the picker highlights what the page is actually doing.
    return localStorage.getItem("theme") || "system"
  }

  _applyTheme(theme) {
    const dark =
      theme === "dark" ||
      (theme === "system" && this._mediaQuery.matches)
    document.documentElement.classList.toggle("dark", dark)
  }

  _highlight(theme) {
    this.optionTargets.forEach(el => {
      const active = el.dataset.theme === theme
      el.classList.toggle("bg-white",        active)
      el.classList.toggle("dark:bg-slate-700", active)
      el.classList.toggle("shadow-sm",       active)
      el.classList.toggle("text-slate-900",  active)
      el.classList.toggle("dark:text-slate-100", active)
      el.classList.toggle("text-slate-400",  !active)
    })
  }
}
